module.exports = __webpack_public_path__ + "0618975dce2b240ee7b62a1be47c3286.png";